export const packageId = 16 as number;
export const packageInfo = 'com.sambad.99lotto';
export const defaultChannel = 'ins';
export const disabledPhoneCode = true;
export const apiSendPhoneCode = false;
export const defaultPhoneCode = '91';
export const homePage = 'Index';
export const defaultApkPath = 'zeus';
export const defaultApkName = 'zeusbet-ins.apk';
export const defaultApkPrefix = 'zeusbet-';
export const gameNavigateVersion = 1;
